export class WebStatusObs {
    idObs: number;
    nrCpf: string;
    nmUsuario: string;
    mensagem: string;
    dtObs: Date;
}